import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['btn'];

  connect() {
    this.handleScroll(); // Call the original scroll functionality
    this.initPageOverviewScroll(); // Initialize the new scroll functionality and observing sections
  }

  handleScroll() {
    window.addEventListener('scroll', () => {
      window.scrollY > 20 ? this.btnTarget.classList.remove('hidden') : this.btnTarget.classList.add('hidden');
      // console.log('scrolling');
    });
  }

  initPageOverviewScroll() {
    const pageOverview = document.getElementById('page-overview');
    if (!pageOverview) {
      // Exit if the elements do not exist
      return;
    }

    // Only proceed to set up the scroll event listener and observe section entries if both elements exist
    let lastScroll = 0;

    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      if (currentScroll > lastScroll && currentScroll > 100) {
        // console.log('scrolling down');
        // Scrolling down within the div
        pageOverview.classList.add('-translate-y-20');
        pageOverview.classList.remove('translate-y-0');
      } else if (currentScroll < lastScroll) {
        // Scrolling up within the div
        pageOverview.classList.remove('-translate-y-20');
        pageOverview.classList.add('translate-y-0');
      }

      lastScroll = currentScroll; // Update last scroll position
    });
  }

  scrollTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
}
